export const entity = {
  usage: {
    name: 'Usage',
  },
};
